/**
 * Gateway provider config for transactions (LinkMePay, BTCPay, 0xProcessing, GGUSOnePay).
 * Used for labels and badge styling on Transactions page.
 * Badge colors follow the same `bg-*-100` / `text-*-800` pattern; each gateway has its own hue.
 */
export const PROVIDER_CONFIG = {
  linkmepay: {
    label: 'LinkMePay',
    bgClass: 'bg-blue-100',
    textClass: 'text-blue-800',
  },
  btcpay: {
    label: 'BTCPay',
    bgClass: 'bg-orange-100',
    textClass: 'text-orange-800',
  },
  zeroxprocessing: {
    label: '0xProcessing',
    bgClass: 'bg-violet-100',
    textClass: 'text-violet-800',
  },
  ggusonepay: {
    label: 'GGUSOnePay',
    bgClass: 'bg-teal-100',
    textClass: 'text-teal-800',
  },
  shop_player_cash: {
    label: 'Shop counter',
    bgClass: 'bg-emerald-100',
    textClass: 'text-emerald-800',
  },
  agent_cash: {
    label: 'Agent cash',
    bgClass: 'bg-amber-100',
    textClass: 'text-amber-800',
  },
  super_agent_cash: {
    label: 'Super agent cash',
    bgClass: 'bg-indigo-100',
    textClass: 'text-indigo-800',
  },
  portal_usd_withdrawal: {
    label: 'Portal USD withdrawal',
    bgClass: 'bg-sky-100',
    textClass: 'text-sky-800',
  },
} as const;

export type ProviderType = keyof typeof PROVIDER_CONFIG;

export const PROVIDER_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'All Gateways' },
  { value: 'linkmepay', label: 'LinkMePay' },
  { value: 'btcpay', label: 'BTCPay' },
  { value: 'zeroxprocessing', label: '0xProcessing' },
  { value: 'ggusonepay', label: 'GGUSOnePay' },
  { value: 'shop_player_cash', label: 'Shop counter' },
  { value: 'agent_cash', label: 'Agent cash' },
  { value: 'super_agent_cash', label: 'Super agent cash' },
  { value: 'portal_usd_withdrawal', label: 'Portal USD withdrawal' },
];
